import { useEffect, useRef, useState } from "react";
import { useUserXp } from "../../hooks/useUserXp";
import { useAchievementsSeen } from "../../hooks/useAchievementsSeen";
import * as analytics from "../../utils/analytics";
import { levelCelebration } from "../../utils/achievementCelebration";
import AchievementUnlockedToast from "./AchievementUnlockedToast";

export default function LevelUpNotice() {
    const { progress, hasProgress } = useUserXp();
    const { seen, markSeen } = useAchievementsSeen();
    const previousLevelRef = useRef<number>();
    const announcedRef = useRef(new Set<number>());
    const [level, setLevel] = useState<number | null>(null);

    useEffect(() => {
        if (!hasProgress) return;
        const previous = previousLevelRef.current;
        previousLevelRef.current = progress.level;
        if (previous === undefined || progress.level <= previous || announcedRef.current.has(progress.level)) return;
        const achievement = levelCelebration(progress.level);
        const id = achievement.id;
        if (seen[id] === "seen") return;
        announcedRef.current.add(progress.level);
        markSeen(id);
        analytics.track("achievement_celebration_displayed", { achievement_type: "level" });
        setLevel(progress.level);
    }, [hasProgress, progress.level, seen, markSeen]);

    if (level === null) return null;
    return <AchievementUnlockedToast level={level} onDismiss={() => setLevel(null)} />;
}
